import type { BillingBalanceInfo, BillingStatus } from '@/types';

/** Autumn `hiromatch_candidates` balance (v3.5.2 Billing SSOT). */
export function getCandidatesBalance(
  status: BillingStatus | null | undefined,
): BillingBalanceInfo | undefined {
  return status?.balances?.candidates;
}

export function getCandidatesLimit(status: BillingStatus): number {
  return status.limits?.candidates ?? status.balances?.candidates?.granted ?? 0;
}

export function getCandidatesUsed(status: BillingStatus): number {
  const b = status.balances?.candidates;
  if (!b || b.unlimited || status.isUnlimited) return 0;
  return Math.max(0, b.granted - b.remaining);
}

/** Remaining slots for CapUsageWidget (`granted - used` display math). */
export function getCandidatesRemainingDisplay(status: BillingStatus): number {
  const limit = getCandidatesLimit(status);
  return Math.max(0, limit - getCandidatesUsed(status));
}

/** Room to resume / submit CV screening (Autumn check mirror for UI). */
export function hasCandidatesProcessingCredits(
  status: BillingStatus | null | undefined,
): boolean {
  if (!status) return false;
  if (status.isUnlimited) return true;
  const b = status.balances?.candidates;
  if (!b) return false;
  if (b.unlimited) return true;
  return b.remaining > 0;
}
